import "./App.css";
import Pettipettimain from './pettiPettiMirissa/pettipettimain';
import Pettipettidine from './pettiPettiMirissa/pettipettidine';
import Pettipettiabout from "./pettiPettiMirissa/pettipettiabout";
import Pettipetticontact from "./pettiPettiMirissa/pettipetticontact";
import Pettipettievent from "./pettiPettiMirissa/pettipettievent";
import Pettipettigallery from "./pettiPettiMirissa/pettipettifgallery";
import Pettipettilounge from "./pettiPettiMirissa/pettipettilounge";
import Pettipettioffers from "./pettiPettiMirissa/pettipettioffers";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



function App() {
  return (
    <Router>
    <main>
          <Routes>
            <Route path="/" element={<Pettipettimain />} />
            <Route path="/about" element={<Pettipettiabout />} />
            <Route path="/contact" element={<Pettipetticontact />} />
            <Route path="/events" element={<Pettipettievent />} />
            <Route path="/offers" element={<Pettipettioffers />} />
            <Route path="/gallery" element={<Pettipettigallery />} />
            <Route path="/dining" element={<Pettipettidine />} />
            <Route path="/lounge" element={<Pettipettilounge />} />
          </Routes>
        </main>
    </Router>
  );
}

export default App;
